import React from 'react'
import { ToastNotification } from 'components/Zui'

const index = ({ id, title, description, icon, readStatus, timeStamp, handleMarkRead }) => {
    if (title.length > 32) title = `${title.slice(0, 32)} ...`

    return (
        <div
            className="bell-flyout-notification-item-wrapper"
            onClick={() => {
                !readStatus && handleMarkRead(id)
            }}
        >
            <ToastNotification
                state="default"
                style={{
                    borderRadius: 'none',
                    boxShadow: 'none',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderRight: 'none',
                }}
            >
                <span slot="headerText">{title}</span>
                <span style={{ cursor: 'pointer' }}>{description}</span>
                {icon}
            </ToastNotification>
            {!readStatus && <div className="notification-read-status"></div>}

            <div className="notification-time-stamp">
                <span>{timeStamp}</span>
            </div>
        </div>
    )
}

export default index
